import { signal } from '@preact/signals';

import { api } from '../api.js';

// Golf 8 (0050): wat een meekijker mag zien (voor de navigatie). De server blijft de bron: zonder
// het recht 'agenda zien' geeft /v1/app/agenda 403, ook als de knop er toch staat.

export const relativeSeesAgenda = signal(false);

/** Leest de eigen rechten van de meekijker in het actieve huishouden; fouten zijn stil. */
export async function loadRelativeRights(): Promise<void> {
  try {
    const o = await api.care.overview();
    relativeSeesAgenda.value = o.role === 'relative' && o.me.sees_agenda;
  } catch {
    relativeSeesAgenda.value = false;
  }
}
